window.dataLayer = window.dataLayer || [];

/* start add to cart datalayer */
document.addEventListener("DOMContentLoaded", function () {
  const AddToCartButtons = document.querySelectorAll(".datalayer-add-to-cart");
  AddToCartButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const productId = button.getAttribute("data-id");
      const productName = button.getAttribute("data-name");
      const variantName = button.getAttribute("data-variant");
      const productPrice = button.getAttribute("data-price");
      const currency = button.getAttribute("data-currency");
      const productVendor = button.getAttribute("data-vendor");
      const productUrl = button.getAttribute("data-url");
      const productType = button.getAttribute("data-type");
      const timestamp = Date.now();
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currencyCode: currency,
          add: {
            products: [
              {
                name: productName,
                id: productId,
                variant: variantName,
                price: productPrice,
                vendor: productVendor,
                url: productUrl,
                type: productType,
                timestamp: timestamp,
              },
            ],
          },
        },
      });
    });
  });
});
/* end add to cart datalayer */
